<template>
  <v-data-table
    v-bind="$attrs"
    :loading="loading"
    :pagination.sync="pagination"
    :selected.sync="selected"
    :total-items="pagination.totalItems"
    :rows-per-page-text="$t('Rows per page')"
    class="elevation-1"
    item-key="id"
    v-on="$listeners"
  >
    <v-progress-linear
      slot="progress"
      color="primary"
      indeterminate
    />
    <template
      v-slot:[slot]="scope"
      v-for="(_, slot) of $scopedSlots">
      <slot
        :name="slot"
        v-bind="scope"
        v-on="$listeners"/>
    </template>
    <template slot="no-data">
      <v-btn
        color="primary"
        @click="$emit('reset')"
      >
        {{ $t('Reset') }}
      </v-btn>
    </template>
    <template v-slot:pageText="props">
      <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DataTable',

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters({
      loading: 'pagination/loading'
    }),

    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:selected', value)
      }
    },

    pagination: {
      get () {
        return this.$store.getters['pagination/status']
      },
      set (value) {
        this.$store.dispatch('pagination/updateSorting', value)
      }
    }
  }
}
</script>

<style>
  .v-datatable__row a {
    text-decoration: none;
  }
  .v-datatable__row a:hover {
    text-decoration: underline;
  }
</style>
